import { spacingHelper, TabList, radiusHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';

const lightBoxWidth = '294px';

export const MediaGalleryTimelineContainer = styled.div`
  width: ${lightBoxWidth};
  background: rgb(0 0 0 / 90%);
  border-radius: calc(${radiusHelper('large')} / 2);
  margin-bottom: ${spacingHelper('large')};
`;

export const mediaGalleryTabClassNames = {
  floatyLine: 'floatyLine',
  tabButton: 'tabButton',
} as const;

export const mediaGalleryTabListClassNames = {
  tabList: 'media-timeline-tab-list',
  leftChevronWrapper: 'media-timeline-leftChevronWrapper',
  leftScrollControl: 'media-timeline-leftScrollControl',
  leftFadeySpacer: 'media-timeline-leftFadeySpacer',
  leftScrollIcon: 'media-timeline-leftScrollIcon',
  rightChevronWrapper: 'media-timeline-rightChevronWrapper',
  rightScrollControl: 'media-timeline-rightScrollControl',
  rightFadeySpacer: 'media-timeline-rightFadeySpacer',
  rightScrollIcon: 'media-timeline-rightScrollIcon',
} as const;

export const MediaGalleryTimelineTabList = styled(TabList)<{ $tabCount: number }>`
  .${mediaGalleryTabListClassNames.tabList} {
    margin: 0; /*  override default margin from CK so can align with chevron */
    border-radius: calc(${radiusHelper('large')} / 2);
    display: inline-flex;
    gap: ${spacingHelper('medium')};
    padding: 0 5%;
    ${({ $tabCount }) =>
      $tabCount > 5 ? 'justify-content: space-between;' : 'justify-content: center;'};

    > li {
      width: unset;
    }
  }

  .${mediaGalleryTabClassNames.tabButton} {
    padding: ${spacingHelper('twoExtraSmall')};
    text-decoration: none;
    &:hover {
      background: inherit;
    }
  }

  .${mediaGalleryTabListClassNames.leftChevronWrapper},
    .${mediaGalleryTabListClassNames.rightChevronWrapper} {
    top: 0;
  }

  .${mediaGalleryTabListClassNames.leftScrollControl} {
    border-radius: calc(${spacingHelper('small')} / 2) 0 0 calc(${spacingHelper('small')} / 2);
    border-bottom: none;
  }

  .${mediaGalleryTabListClassNames.rightScrollControl} {
    border-radius: 0 calc(${spacingHelper('small')} / 2) calc(${spacingHelper('small')} / 2) 0;
    border-bottom: none;
  }

  .${mediaGalleryTabListClassNames.leftFadeySpacer},
    .${mediaGalleryTabListClassNames.rightFadeySpacer} {
    height: auto;
    border-top: none;
    border-bottom: none;
  }

  .${mediaGalleryTabClassNames.floatyLine} {
    bottom: 5px;
  }
`;
